import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import CommentsRenderer from "../../renderers/CommentsRenderer";
import CommentThreadPreviewTooltip from "../../tooltips/CommentThreadPreviewTooltip";

const CellRendererCommentsThreadPreview = ({ loan, comments }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  // const tooltipContent = (
  //   <Box
  //     sx={{
  //       display: "flex",
  //       flexDirection: "column",
  //       flexGrow: 1,
  //       overflow: "hidden",
  //     }}
  //   >
  //     <Txt
  //       bold
  //       sx={{
  //         color: `${grey[700]} !important`,
  //         mb: 0.5,
  //       }}
  //     >
  //       Comments ({size(comments)})
  //     </Txt>

  //     <Box
  //       sx={{
  //         flexGrow: 1,
  //         overflowY: "auto",
  //         maxHeight: "540px",
  //         minWidth: "500px",
  //         borderRadius: 1.2,
  //         border: `1px solid ${grey[200]}`,
  //       }}
  //     >
  //       <EnhancedCommentItemRenderer
  //         sx={{ width: "100%" }}
  //         loan={loan || loanDrilldown}
  //         comments={comments}
  //       />
  //     </Box>
  //   </Box>
  // );

  return (
    <CommentThreadPreviewTooltip
      enhanced
      loan={loanDrilldown}
      comments={comments}
    >
      <Box>
        <CommentsRenderer onlyCount comments={comments} />
      </Box>
    </CommentThreadPreviewTooltip>
  );
  // return (
  //   <Tooltip
  //     title={tooltipContent}
  //     placement="left"
  //     disableInteractive={false}
  //     componentsProps={{
  //       tooltip: {
  //         sx: {
  //           bgcolor: "background.paper",
  //           color: "text.primary",
  //           boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
  //           borderRadius: "8px",
  //           border: `1px solid ${grey[200]}`,
  //           p: 1.5,
  //           maxWidth: "none", // removes MUI's default 300px cap
  //         },
  //       },
  //       arrow: {
  //         sx: {
  //           color: "background.paper",
  //           "&::before": {
  //             border: `1px solid ${grey[200]}`,
  //           },
  //         },
  //       },
  //     }}
  //   >
  //     <Box>
  //       <CommentsRenderer onlyCount comments={comments} />
  //     </Box>
  //   </Tooltip>
  // );
};

export default CellRendererCommentsThreadPreview;
